import { db } from './api';
import { collection, getDocs, query,} from "firebase/firestore";


// Estructura de la colección de medicamentos
export interface Medicine {
    category: string;
}


/**
 * Función que obtiene todos los medicamentos de la base de datos
 * @returns {Promise<Array<Medicine>>} Promesa con el arreglo de medicamentos
 */
export async function getMedicines() {
    const medicines: Array<Medicine> = [];
    const q = query(collection(db, "medicines"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
        medicines.push(
            doc.data() as Medicine
        );
    });
    return medicines;
}